import { Container, Grid } from '@material-ui/core'
import { equals } from '@soltalabs/ramda-extra'
import React, { memo, useRef, useState } from 'react'

import { TitleLabel } from '../../common/styles'
import { ImportJobsButtons } from '../ImportJobsButtons'
import { JobsList } from '../JobsList'
import { Map } from '../Map'
import { MapErrorBoundary } from '../Map/MapErrorBoundary'
import { MapToggles } from '../MapToggles'
import { SearchBar } from '../SearchBar'
import { SortbySelect } from '../SortbySelect'

import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css'

const DashboardView = ({
  jobList,
  showMapView,
  sortBy,
  onShowMapView,
  onHideMapView,
  onSelectSortBy,
  dispatchSetAddJobAddress,
  dispatchSetAddJobLocation,
  dispatchSetSelectedJob,
}) => {
  const mapContainerRef = useRef(null)
  const mapRef = useRef(null)
  const [mapReady, setMapReady] = useState(false)

  return (
    <Container maxWidth="lg" style={{ marginLeft: 0, marginRight: 0 }}>
      <Grid container direction="row" spacing={4}>
        <Grid item xs={4}>
          <TitleLabel>Jobs Overview</TitleLabel>
          <SortbySelect value={sortBy} onChange={onSelectSortBy} />

          <JobsList
            show={showMapView}
            jobList={jobList}
            sortBy={sortBy}
            distance={1}
            axis="xy"
            cols={1}
            spacing={10}
            mapContainerRef={mapContainerRef}
          />
        </Grid>

        <Grid item xs={8}>
          <ImportJobsButtons />

          <Grid container justify="space-between" alignItems="center">
            {mapReady && (
              <SearchBar
                mapRef={mapRef}
                mapContainerRef={mapContainerRef}
                dispatchSetAddJobAddress={dispatchSetAddJobAddress}
                dispatchSetAddJobLocation={dispatchSetAddJobLocation}
                dispatchSetSelectedJob={dispatchSetSelectedJob}
              />
            )}
            <MapToggles
              showMapView={showMapView}
              onShowMapView={onShowMapView}
              onHideMapView={onHideMapView}
            />
          </Grid>

          <MapErrorBoundary>
            <Map
              ref={mapContainerRef}
              mapRef={mapRef}
              show={showMapView}
              jobList={jobList}
              onMapReady={() => setMapReady(true)}
              dispatchSetAddJobAddress={dispatchSetAddJobAddress}
              dispatchSetAddJobLocation={dispatchSetAddJobLocation}
              dispatchSetSelectedJob={dispatchSetSelectedJob}
            />
          </MapErrorBoundary>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <JobsList
            show={!showMapView}
            jobList={jobList}
            sortBy={sortBy}
            distance={1}
            axis="xy"
            cols={3}
            spacing={32}
            mapContainerRef={mapContainerRef}
          />
        </Grid>
      </Grid>
    </Container>
  )
}

const MemoedDashboardView = memo(DashboardView, equals)

export { MemoedDashboardView as DashboardView }
